import { Segmented } from "antd";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { useLocation } from "react-router-dom";
import "./switchLanguage.css";

const SwitchLanguage = () => {
  const { i18n } = useTranslation();
  const navigate = useLangNavigate();
  const location = useLocation();

  const changeLanguage = (newLang) => {
    if (newLang === i18n.language) return;

    const newPath = location.pathname.replace(
      `/${i18n.language}`,
      `/${newLang}`
    );
    i18n.changeLanguage(newLang);

    navigate({
      pathname: newPath,
      search: location.search,
      replace: true,
    });

    // dispatch(_Remove_All_Bookings());

    // document.body.dir = newLang === 'ar' ? 'rtl' : 'ltr';
  };

  return (
    <div className="LangWrapper">
      <Segmented
        options={[
          { label: "AR", value: "ar" },
          { label: "EN", value: "en" },
        ]}
        value={i18n.language}
        onChange={changeLanguage}
        className="customSegmented"
      />
    </div>
  );
};

export default SwitchLanguage;
